/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path appbar
 * @description App bar for the system

 * @section 4.2.1
 * @section 4.2.1.5
 * @section 4.2.1.4
 *
 */
import { createContext } from "react";
export interface AppBarContextInterface {
  language: string;
  showAppBar: boolean;
  showPeriodSelector: boolean;
  selectedPeriod: any;
  setLanguage: (value: string) => void;
  setAppBar: (value: boolean) => void;
  setPeriodSelector: (value: boolean) => void;
  setPeriod: (value: any) => void;
  getPeriodName: () => string;
}
const initialAppBarContext = {
  language: "EN",
  showAppBar: true,
  showPeriodSelector: true,
  selectedPeriod: undefined,
  setLanguage: (value: string): void => {},
  setAppBar: (): void => {},
  setPeriod: (): void => {},
  setPeriodSelector: (): void => {},
  getPeriodName: (): string => "",
};
const AppBarContext =
  createContext<AppBarContextInterface>(initialAppBarContext);
export default AppBarContext;
